// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22721":"b142b1fd","87646":"bbd61af8"}[chunkId] + ".chunk.css";
};